import { render } from "./EpisodeApplePodcastsLink.vue.js?vue&type=template&id=5847b0ef!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeApplePodcastsLink.vue?vue&type=template&id=5847b0ef"
import script from "./EpisodeApplePodcastsLink.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeApplePodcastsLink.vue?vue&type=script&lang=js"
export * from "./EpisodeApplePodcastsLink.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeApplePodcastsLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/episode-page/EpisodeApplePodcastsLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5847b0ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5847b0ef', __exports__)) {
    api.reload('5847b0ef', __exports__)
  }
  
  module.hot.accept("./EpisodeApplePodcastsLink.vue.js?vue&type=template&id=5847b0ef!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EpisodeApplePodcastsLink.vue?vue&type=template&id=5847b0ef", () => {
    api.rerender('5847b0ef', render)
  })

}


export default __exports__